import Page from "../../framework/Page";
import View from "../../framework/View";

export default class TitleView extends View {
    /**
     * @param {string} parentId 
     */
    constructor(parentId) {
        super(parentId, parentId + '_title');
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        ////////////////////
        // Game Title
        ////////////////////

        const gameTitleContainer = Page.createElement('div', parentElement, null, 'game-title-container');
        const gameTitleBody = Page.createElement('div', gameTitleContainer, null, 'game-title-body');
        
        const gameTitle1 = Page.createElement('div', gameTitleBody, null, 'game-title-display');
        gameTitle1.innerHTML = 'Mining';

        const gameTitle2 = Page.createElement('div', gameTitleBody, null, 'game-title-display');
        gameTitle2.innerHTML = 'Crew';

        super.initializeView();
    }
}